
import { Button } from "@/components/ui/button";
import { Plus, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ContractTypesHeaderProps {
  onDeleteAllClick: () => void;
  hasContractTypes: boolean;
}

export function ContractTypesHeader({ onDeleteAllClick, hasContractTypes }: ContractTypesHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">{t('contractTypes.title', 'Contract Types')}</h1>
        <p className="text-muted-foreground mt-2">
          {t('contractTypes.description', 'Manage contract types')}
        </p>
      </div>
      <div className="flex gap-2">
        <Button 
          variant="destructive"
          onClick={onDeleteAllClick}
          disabled={!hasContractTypes}
        >
          <Trash2 className="h-4 w-4 mr-2" />
          {t('contractTypes.deleteAll', 'Delete All')}
        </Button>
        <Button asChild>
          <Link to="/contract-types/new">
            <Plus className="h-4 w-4 mr-2" />
            {t('contractTypes.add', 'Add Contract Type')}
          </Link>
        </Button>
      </div>
    </div>
  );
}
